import { render, staticRenderFns } from "./order-reorder-row.vue?vue&type=template&id=38f3b6e4&scoped=true"
import script from "./order-reorder-row.vue?vue&type=script&lang=js"
export * from "./order-reorder-row.vue?vue&type=script&lang=js"
import style0 from "./order-reorder-row.vue?vue&type=style&index=0&id=38f3b6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3b6e4",
  null
  
)

export default component.exports